import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import { CheckboxCheck } from "./CheckboxCheck";
import {
  CHECKBOX_DEFAULTS,
  CHECKBOX_ORIENTATION_CLASS_MAP,
  CHECKBOX_VARIANT_CLASS_MAP,
  TCheckboxProps,
} from "./Checkbox.config";
import { Field } from "../Field";
import { Label } from "../Label";
import { TextBody } from "../../typography/TextBody";

export const Checkbox: FC<TCheckboxProps> = (
  {
    label,
    description,
    orientation = CHECKBOX_DEFAULTS.orientation,
    variant = CHECKBOX_DEFAULTS.variant,
    input,
    className,
    ...props
  },
) => {
  const disabled = input?.disabled;

  return (
    <Field
      {...props}
      data-component="Checkbox"
      className={cn(
        "cursor-pointer grid gap-x-2",
        disabled && "cursor-not-allowed",
        CHECKBOX_ORIENTATION_CLASS_MAP[orientation],
        CHECKBOX_VARIANT_CLASS_MAP[variant],
        className,
      )}
    >
      <div className="col-start-1 row-start-1 self-center">
        <input
          {...input}
          type="checkbox"
          className="sr-only peer"
        />
        <CheckboxCheck />
      </div>

      <Label
        className={cn(
          "col-start-2 row-start-1 peer-disabled:opacity-70",
          disabled && "opacity-70",
        )}
      >{ label }</Label>

      { description ? (
        <div className="col-start-2 row-start-2 pt-1.5">
          <TextBody size={2} color="secondary" isResponsive={false}>
            { description }
          </TextBody>
        </div>
      ) : null }
    </Field>
  );
};

Checkbox.displayName = "Checkbox";
